/* ==========================================================================
   C13 HEALTH - Wishlist page renderer
   Reads handles from localStorage (shared with c13-core.js) and hydrates
   each one from Shopify's product JSON endpoint.
   Supports ?list=handle-a,handle-b for sharing a list between devices.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function init() {
    var root = $('[data-c13-wishlist-page]');
    if (!root) return;

    var grid    = $('[data-c13-wish-grid]', root);
    var full    = $('[data-c13-wish-full]', root);
    var empty   = $('[data-c13-wish-empty]', root);
    var loading = $('[data-c13-wish-loading]', root);
    var totalEl = $('[data-c13-wish-total]', root);
    var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';

    var Wish = (window.C13 && window.C13.wishlist) || {
      read: function () { try { return JSON.parse(localStorage.getItem('c13:wishlist:v1') || '[]'); } catch (e) { return []; } },
      write: function (l) { try { localStorage.setItem('c13:wishlist:v1', JSON.stringify(l)); } catch (e) {} },
      remove: function (h) { var l = this.read(), i = l.indexOf(h); if (i > -1) { l.splice(i, 1); this.write(l); } }
    };

    /* Merge a shared list from the URL into the local one */
    var params = new URLSearchParams(window.location.search);
    var shared = params.get('list');
    if (shared) {
      var incoming = shared.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var merged = Wish.read();
      incoming.forEach(function (h) { if (merged.indexOf(h) === -1) merged.push(h); });
      Wish.write(merged);
      if (window.C13 && window.C13.toast) window.C13.toast('Shared list added to yours');
      window.history.replaceState({}, '', window.location.pathname);
    }

    function money(cents) {
      var n = cents / 100;
      var value = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (/amount_no_decimals/.test(moneyFormat)) value = Math.round(n).toLocaleString('en-GB');
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, value);
    }

    function thumb(url, w) {
      if (!url) return '';
      return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
    }

    function card(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var title = p.title.replace(/^The Silent Fire\s*[-—]\s*/, '');
      var v = (p.variants && p.variants[0]) || {};
      var isExternal = /ebook|e-book|amazon/i.test(p.title);
      var available = p.available !== false;

      return '' +
      '<article class="c13-ecard" data-handle="' + esc(p.handle) + '">' +
        '<button type="button" class="c13-wish__remove" data-c13-wish-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(title) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="c13-ecard__media"><div class="c13-ratio c13-ratio--3-4">' +
          (img ? '<img class="c13-img is-loaded c13-ecard__img" src="' + esc(thumb(img, 640)) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async">' : '<div class="c13-ratio__fill c13-skeleton"></div>') +
        '</div></div>' +
        '<div class="c13-ecard__body">' +
          '<h3 class="c13-ecard__title"><a href="/products/' + esc(p.handle) + '">' + esc(title) + '</a></h3>' +
          '<p class="c13-ecard__price">' + (isExternal ? 'Read anywhere' : money(p.price != null ? p.price : v.price)) + '</p>' +
          (isExternal
            ? '<a class="c13-btn c13-btn--outline c13-btn--sm c13-ecard__cta" href="/products/' + esc(p.handle) + '">View edition</a>'
            : (available
                ? '<button type="button" class="c13-btn c13-btn--outline c13-btn--sm c13-btn--block c13-ecard__cta" data-c13-wish-add="' + esc(v.id) + '" data-title="' + esc(title) + '">Add to bag</button>'
                : '<a class="c13-btn c13-btn--outline c13-btn--sm c13-ecard__cta" href="/products/' + esc(p.handle) + '">Pre-order</a>')) +
        '</div>' +
      '</article>';
    }

    function show(state) {
      if (loading) loading.hidden = state !== 'loading';
      if (full)    full.hidden    = state !== 'full';
      if (empty)   empty.hidden   = state !== 'empty';
    }

    function render() {
      var handles = Wish.read();
      if (!handles.length) { show('empty'); return; }
      show('loading');

      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (items) {
        var good = [];
        items.forEach(function (p, i) {
          if (p) { good.push(p); }
          else { Wish.remove(handles[i]); }   /* prune products that no longer exist */
        });

        if (!good.length) { show('empty'); return; }
        grid.innerHTML = good.map(card).join('');
        if (totalEl) totalEl.textContent = good.length;
        show('full');
      });
    }

    /* --- interactions --- */
    root.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null;
      if (!t) return;

      var rm = t.closest('[data-c13-wish-remove]');
      if (rm) {
        Wish.remove(rm.getAttribute('data-c13-wish-remove'));
        render();
        if (window.C13 && window.C13.toast) window.C13.toast('Removed from your list');
        return;
      }

      var add = t.closest('[data-c13-wish-add]');
      if (add) {
        var id = add.getAttribute('data-c13-wish-add');
        var label = add.textContent;
        add.disabled = true; add.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.C13 && window.C13.toast) window.C13.toast(add.getAttribute('data-title') + ' added to your bag', 'View bag', '/cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-c13-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-visible', cart.item_count > 0);
          });
        })
        .catch(function () { if (window.C13 && window.C13.toast) window.C13.toast('Could not add that just now'); })
        .finally(function () { add.disabled = false; add.textContent = label; });
        return;
      }

      if (t.closest('[data-c13-wish-clear]')) {
        Wish.write([]);
        render();
        return;
      }

      if (t.closest('[data-c13-wish-addall]')) {
        var btns = $$('[data-c13-wish-add]', grid);
        if (!btns.length) return;
        var items = btns.map(function (b) { return { id: Number(b.getAttribute('data-c13-wish-add')), quantity: 1 }; });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.C13 && window.C13.toast) window.C13.toast(items.length + ' items added to your bag', 'View bag', '/cart');
        })
        .catch(function () { if (window.C13 && window.C13.toast) window.C13.toast('Could not add those just now'); });
        return;
      }

      if (t.closest('[data-c13-wish-share]')) {
        var url = window.location.origin + window.location.pathname + '?list=' + Wish.read().join(',');
        var done = function () { if (window.C13 && window.C13.toast) window.C13.toast('Share link copied'); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copy your list link', url); });
        } else {
          window.prompt('Copy your list link', url);
        }
      }
    });

    document.addEventListener('c13:wishlist:change', function () {
      /* only re-render when the change came from elsewhere on the page */
      if (!grid.querySelector('[data-handle]')) render();
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
